export class PagosModel {
    constructor(
        public idCliente: number,
        public idCredito: number,
        public valor: any,
        public saldo: any , 
        public costoInicial: any
    ) { }
}